import { Box, Typography, styled } from "@mui/material";
import { CustomDisplayItem } from "@/components/custom/custom-display-item";
import { formatUnderscoreLabel } from "@/utils/format-underscore-label";
import { DocumentLink } from "@/utils/format-document-link";

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const SectionTitle = ({ title, description }) => (
  <Side>
    <Typography fontWeight={500} fontSize={18}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    )}
  </Side>
);

const KycDocuments = ({ d }) => {
  console.log("data.businessAddressProveUrl", d.memartCertificateUrl);
  return (
    <Row>
      <SectionTitle
        title="Documents & Certificates"
        description="Uploaded business documents and verification files."
      />
      <Grid>
        <DocumentLink
          label="MEMART Certificate"
          url={d?.memartCertificateUrl}
        />
        <DocumentLink label="CAC IT Certificate" url={d?.cacItCertificateUrl} />
        <DocumentLink label="CAC BN Certificate" url={d?.cacBnCertificateUrl} />
        <DocumentLink
          label="Incorporation Certificate"
          url={d?.incorporationCertificateUrl}
        />
        <DocumentLink
          label="Business Name Certificate"
          url={d?.businessNameCertificateUrl}
        />
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Address Proof Type"
            value={formatUnderscoreLabel(d?.businessAddressProveType)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <DocumentLink
            label="Address Proof"
            url={d?.businessAddressProveUrl}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Identification Type"
            value={formatUnderscoreLabel(d?.identificationType)}
          />
        </Box>
        <DocumentLink
          label="Identification Document"
          url={d?.identificationUrl}
        />
        <DocumentLink label="Business Logo" url={d?.businessLogoUrl} />
      </Grid>
    </Row>
  );
};

export default KycDocuments;
